import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { ICrawling, IGroup, IUser } from 'common';
import { ActionButton } from '../ActionButton';
import { Modal } from '../Modal';
import { CrawlingFormFields } from '../CrawlingFormFields';
import { ADALONG_COLORS } from '../../styles';

interface CrawlingEditDialogProps {
  open: boolean;
  onClose: () => void;
  crawling?: ICrawling | null;
  groups: IGroup[];
  users: IUser[];
  onSave: (crawling: Partial<ICrawling>) => Promise<void>;
  // For creation mode - pre-fill these values
  defaultHashtag?: string;
  defaultGroup?: IGroup;
}

export function CrawlingEditDialog(props: CrawlingEditDialogProps) {
  const isCreating = !props.crawling;
  const [validCrawling, setValidCrawling] = useState<Partial<ICrawling> | null>(null);

  const handleSave = () => {
    if (!validCrawling) {
      return;
    }

    props.onSave(validCrawling).then(() => {
      props.onClose();
    });
  };

  const title = isCreating 
    ? `Create Crawling for #${props.defaultHashtag}` 
    : `Edit Crawling: #${props.crawling?.hashtag}`;

  return (
    <Modal onClose={props.onClose}>
      <Dialog 
        open={props.open} 
        onClose={props.onClose} 
        maxWidth="sm" 
        fullWidth
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          sx: {
            bgcolor: ADALONG_COLORS.DARK_BLACK,
            color: ADALONG_COLORS.LIGHT_WHITE,
            borderRadius: '20px',
            border: `1px solid ${ADALONG_COLORS.LIGHT_BLACK}`,
            backgroundImage: 'none',
          },
        }}
      >
        <DialogTitle sx={{ color: ADALONG_COLORS.LIGHT_WHITE, fontSize: '1.5rem', fontWeight: 'bold', pt: 3, px: 4, mb: 0 }}>
          {title}
        </DialogTitle>
        <DialogContent sx={{ pt: '10px !important', pb: 3, px: 4 }}>
          <CrawlingFormFields
            crawling={props.crawling}
            groups={props.groups}
            users={props.users}
            onValidItem={setValidCrawling}
            defaultHashtag={props.defaultHashtag}
            defaultGroup={props.defaultGroup}
          />
        </DialogContent>
        <DialogActions sx={{ px: 4, pb: 4 }}>
          <ActionButton 
            variant="gray" 
            onAction={props.onClose}
          >
            Cancel
          </ActionButton>
          <ActionButton 
            variant="blue" 
            onAction={handleSave} 
            disabled={!validCrawling}
          >
            Save
          </ActionButton>
        </DialogActions>
      </Dialog>
    </Modal>
  );
}
